import { Navigate, Outlet } from "react-router-dom";
import { PATH_CAREER_CARD } from "../constants/routes";

const PublicRoute = (props : any) => {
      if (props.isAuthenticated === null) return <p>Loading...</p>; 

    return props.isAuthenticated ? <Navigate to={PATH_CAREER_CARD} /> : <Outlet />;
};

export default PublicRoute;
